import React from "react";

export default function FaqIcon() {
  return (
    <svg
      width="23"
      height="13"
      viewBox="0 0 23 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.1286 2.225L12.6962 12.247C12.0477 12.9359 10.9528 12.9359 10.3044 12.247L0.871862 2.225C0.16319 1.47195 0.697019 0.236328 1.73108 0.236328H21.2693C22.3034 0.236328 22.8373 1.47195 22.1286 2.225Z"
        fill="#000"
      />
    </svg>
  );
}
